import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const ReferenceBankGuaranteeContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',

    '.title': {
      display: 'flex',
    },

    '.value': {
      display: 'flex',
      marginLeft: '5px'
    },

    '.link': {
     cursor: 'pointer',
     color: v.ezMainColor,
     textDecoration: 'underline'
    },
  },

  '.link': {
    cursor: 'pointer',
    color: v.ezMainColor,
    textDecoration: 'underline'
   }
})
